export default "<ng-container *ngIf=\"drawingEnabled\">\n    <app-drawing-canvas (drawn)=\"handleDrawn($event)\"></app-drawing-canvas>\n</ng-container>\n";